import { useGetIdentity, useList } from '@pankod/refine-core'

import { Menu, Icons, Select, Radio, Button, Input } from '@pankod/refine-antd'

import {
  IGrade,
  IQuestionType,
  ISubject,
  ITeacherLevel,
  IQuestionStatus,
  IWorkRequestStatus,
  IBloomLevel,
  ITopic,
  IReportTheme,
  ITheme,
  ISubTheme,
  IDifficultyLevel,
  IStrand,
} from 'interfaces'
import { useEffect, useState } from 'react'
import { useUserContext } from 'context/user'
const { AppstoreOutlined, FilterOutlined, CloseCircleOutlined } = Icons
type FilterProps = {
  changeFilters: any
  source: string
  hideFilters: any
}
export const QuestionFilter: React.FC<FilterProps> = ({ changeFilters, source, hideFilters }) => {
  const { data: user } = useGetIdentity()
  const { userRole } = useUserContext()
  const [wrStatusData, setWRStatusData] = useState<any[]>([])
  const [selectedKeys, setSelectedKeys] = useState<any[]>([])
  const [keysFilter, setKeysFilter] = useState<any[]>([])
  const [allQuestionFilters, setAllQuesionFilters] = useState<any[]>([])

  const questionStatusList = useList<IQuestionStatus>({
    queryOptions: { staleTime: Infinity },
    resource: 'question_statuses',
    metaData: {
      fields: ['id', 'name'],
    },
    config: {
      sort: [{ order: 'asc', field: 'name' }],
      pagination: { current: 1, pageSize: 20 },
    },
  })
  const wrStatusList = useList<IWorkRequestStatus>({
    resource: 'work_request_statuses',
    queryOptions: { staleTime: Infinity },
    metaData: {
      fields: ['id', 'name'],
    },
    config: {
      sort: [{ order: 'asc', field: 'name' }],
      pagination: { current: 1, pageSize: 20 },
    },
  })
  useEffect(() => {
    let status_arr: object[] = []
    wrStatusList?.data?.data.map((item: any) => {
      if (
        user &&
        (user?.defaultRole === 'qapprover' ||
          user?.defaultRole === 'qcreator' ||
          user?.defaultRole === 'qreviewer' ||
          user?.defaultRole === 'variantcreator') &&
        item?.name !== 'Draft'
      ) {
        status_arr.push(item)
      } else {
        status_arr.push(item)
      }
    })
    setWRStatusData(status_arr)
  }, [wrStatusList?.data?.data])
  const gradeList = useList<IGrade>({
    queryOptions: { staleTime: Infinity },
    resource: 'grades',

    metaData: {
      fields: ['id', 'name'],
    },
    config: {
      sort: [{ order: 'asc', field: 'name' }],
      pagination: { current: 1, pageSize: 20 },
    },
  })

  const subjectList = useList<ISubject>({
    queryOptions: { staleTime: Infinity },
    resource: 'subjects',
    metaData: {
      fields: ['id', 'name'],
    },
    config: {
      sort: [{ order: 'asc', field: 'name' }],
      pagination: { current: 1, pageSize: 10000 },
    },
  })
  //added
  const bloomsList = useList<IBloomLevel>({
    queryOptions: { staleTime: Infinity },
    resource: 'blooms_levels',
    metaData: {
      fields: ['id', 'name'],
    },
    config: {
      sort: [{ order: 'asc', field: 'name' }],
      pagination: { current: 1, pageSize: 100 },
    },
  })

  const topicList = useList<ITopic>({
    queryOptions: { staleTime: Infinity },
    resource: 'topics',
    metaData: {
      fields: ['id', 'name'],
    },
    config: {
      sort: [{ order: 'asc', field: 'name' }],
      pagination: { current: 1, pageSize: 10000 },
    },
  })
  const reportThemeList = useList<IReportTheme>({
    queryOptions: { staleTime: Infinity },
    resource: 'report_themes',
    metaData: {
      fields: ['id', 'name'],
    },
    config: {
      sort: [{ order: 'asc', field: 'name' }],
      pagination: { current: 1, pageSize: 10000 },
    },
  })
  const themeList = useList<ITheme>({
    queryOptions: { staleTime: Infinity },
    resource: 'themes',
    metaData: {
      fields: ['id', 'name'],
    },
    config: {
      sort: [{ order: 'asc', field: 'name' }],
      pagination: { current: 1, pageSize: 10000 },
    },
  })

  const subThemeList = useList<ISubTheme>({
    queryOptions: { staleTime: Infinity },
    resource: 'sub_themes',
    metaData: {
      fields: ['id', 'name'],
    },
    config: {
      sort: [{ order: 'asc', field: 'name' }],
      pagination: { current: 1, pageSize: 10000 },
    },
  })

  const difficultyLevelList = useList<IDifficultyLevel>({
    queryOptions: { staleTime: Infinity },
    resource: 'difficulty_levels',
    metaData: {
      fields: ['id', 'name'],
    },
    config: {
      sort: [{ order: 'asc', field: 'name' }],
      pagination: { current: 1, pageSize: 10000 },
    },
  })

  const strandsList = useList<IStrand>({
    queryOptions: { staleTime: Infinity },
    resource: 'strands',
    metaData: {
      fields: ['id', 'name'],
    },
    config: {
      sort: [{ order: 'asc', field: 'name' }],
      pagination: { current: 1, pageSize: 10000 },
    },
  })
  //
  // const teacherLevelList = useList<ITeacherLevel>({
  //   resource: "teacher_levels",
  //   metaData: {
  //     fields: ["id", "name"],
  //   },
  //   config: {
  //     sort: [{ order: "asc", field: "name" }],
  //   },
  // });
  //  Filter Array : Add the filters here

  const questionFilters = [
    {
      menuName: `All ${source}`,
      key: 'all',
      isLeaf: false,
      options: [],
      filterKey: 'all',
      filterOp: '',
    },
    {
      menuName: 'Status',
      key: 'status',
      isLeaf: true,
      options: source === 'Work Requests' ? wrStatusData : questionStatusList?.data?.data,
      filterKey: 'status',
      filterOp: 'eq',
    },
    {
      // {
      //   field: 'question_grades.grade_id',
      //   operator: 'eq',
      //   value: '763d0c3d-aabd-4fe3-91b1-8579b3949cdd',
      // },
      menuName: 'Grade',
      key: 'grade',
      isLeaf: true,
      options: gradeList?.data?.data,
      filterKey:
        source === 'Work Requests'
          ? 'workRequestGrades.grade_id'
          : source === 'Paper Work Requests'
          ? 'paperWorkRequestGrades.grade_id'
          : 'question_grades.grade_id',
      filterOp: 'eq',
    },
    {
      menuName: 'Subject',
      key: 'subject',
      isLeaf: true,
      options: subjectList?.data?.data,
      filterKey: 'subject_id',
      filterOp: 'eq',
    },
    {
      menuName: 'Blooms',
      key: 'blooms',
      isLeaf: true,
      options: bloomsList?.data?.data,
      filterKey: 'bloom_level_id',
      filterOp: 'eq',
    },
    {
      menuName: 'Topic',
      key: 'topic',
      isLeaf: true,
      options: topicList?.data?.data,
      filterKey: 'topic_id',
      filterOp: 'eq',
    },
    {
      menuName: 'Report Theme',
      key: 'report_theme',
      isLeaf: true,
      options: reportThemeList?.data?.data,
      filterKey: 'report_theme_id',
      filterOp: 'eq',
    },
    {
      menuName: 'Theme',
      key: 'theme',
      isLeaf: true,
      options: themeList?.data?.data,
      filterKey: 'theme_id',
      filterOp: 'eq',
    },
    {
      menuName: 'Sub Theme',
      key: 'sub_theme',
      isLeaf: true,
      options: subThemeList?.data?.data,
      filterKey: 'sub_theme_id',
      filterOp: 'eq',
    },
    {
      menuName: 'Difficulty',
      key: 'difficulty_level',
      isLeaf: true,
      options: difficultyLevelList?.data?.data,
      filterKey: 'difficulty_level_id',
      filterOp: 'eq',
    },
    {
      menuName: 'Strand',
      key: 'strand',
      isLeaf: true,
      options: strandsList?.data?.data,
      filterKey: 'strand_id',
      filterOp: 'eq',
    },

    // {
    //   menuName: "Teacher Level",
    //   key: "teacherlevel",
    //   isLeaf: true,
    //   options: teacherLevelList?.data?.data,
    //   filterKey: "teacher_level_id",
    //   filterOp: "eq",
    // },
  ]
  // console.log({userRole});
  const handleChange = (filterKey: any, optionId: any, filterOp: any, menuKey: any, optionName: string) => {
    if (menuKey !== 'all') {
      if (!selectedKeys.includes(menuKey)) {
        const details = {
          key: menuKey,
          filterKey: filterKey,
          filterOption: filterOp,
        }
        setSelectedKeys([...selectedKeys, menuKey])
        setKeysFilter([...keysFilter, details])
      }
    } else {
      setSelectedKeys([])
      setKeysFilter([])
    }

    changeFilters(filterKey, optionId, filterOp)
  }

  const handleRemoveFilter = (keyToRemove: any, filterKey: any, filterOption: any) => {
    const updatedKeys = selectedKeys.filter(key => key !== keyToRemove)
    const updateFilterKeys= keysFilter.filter((item:any)=>keyToRemove!==item.key)
    setSelectedKeys(updatedKeys)
    setKeysFilter(updateFilterKeys)
    changeFilters(filterKey, '', filterOption, true)
  }
  const handleSearchChange = (key: string, value: string) => {
    const questionFilterKey =
      key === 'report_theme' ? 'Report Theme' : key === 'sub_theme' ? 'Sub Theme' : key === 'difficulty_level' ? 'Difficulty' : key
    const options =
      key === 'report_theme'
        ? reportThemeList?.data?.data
        : key === 'sub_theme'
        ? subThemeList?.data?.data
        : key === 'difficulty_level'
        ? difficultyLevelList?.data?.data
        : key === 'subject'
        ? subjectList?.data?.data
        : key === 'blooms'
        ? bloomsList?.data?.data
        : key === 'topic'
        ? topicList?.data?.data
        : key === 'strand'
        ? strandsList?.data?.data
        : key === 'theme'
        ? themeList?.data?.data
        : []
    if (Array.isArray(options)) {
      const filteredOptionsArray = (options as { name?: string | number }[]).filter(item =>
        item.name?.toString().toLowerCase().includes(value.toLowerCase())
      )
      questionFilters.forEach(item => {
        if (item.menuName.toLowerCase() === questionFilterKey.toLowerCase()) {
          item.options = filteredOptionsArray
        }
      })
      setAllQuesionFilters(questionFilters)
    }
  }

  const filterArray = allQuestionFilters?.length > 0 ? allQuestionFilters : questionFilters
  return (
    <div className="ams-filter-bar">
      {selectedKeys.length > 0 && (
        <div className="ams-filter-tags">
          {keysFilter.map((item: any) => (
            <Button
              type="dashed"
              icon={<CloseCircleOutlined />}
              onClick={() => handleRemoveFilter(item?.key, item?.filterKey, item.filterOption)}
              style={{ marginRight: 8, marginBottom: 8 }}
              size="small"
              key={item.key}
            >
              {item.key}
            </Button>
          ))}
        </div>
      )}
      <Menu mode="horizontal" defaultSelectedKeys={['all']} className="ams-filter-menu">
        {filterArray?.map((item, idx) =>
          !item?.isLeaf ? (
            <>
              <Menu.Item
                key={`${item?.key}${idx}`}
                hidden={source !== 'Work Requests' && item?.key === 'status' && (userRole === 'qcreator' || userRole === 'qreviewer')}
                icon={<AppstoreOutlined />}
                onClick={() => handleChange(item?.filterKey, '', '', item?.key, '')}
              >
                {/* <Menu.Item key={`${item?.key}${idx}`} hidden={source !== 'Work Requests' && item?.key==='status' && (userRole==='qcreator'|| userRole==='qreviewer')} icon={<AppstoreOutlined />} onClick={() => changeFilters(item?.filterKey, '', '')}> */}
                {item?.menuName}
              </Menu.Item>
            </>
          ) : (
            <>
              {hideFilters?.length > 0 ? (
                !hideFilters.includes(item?.key) ? (
                  <Menu.SubMenu
                    key={`${item?.key}${idx}`}
                    className={selectedKeys.includes(item.key) ? 'ams-filter-item--active' : ''}
                    style={{
                      display:
                        source !== 'Work Requests' && item?.key === 'status' && (userRole === 'qcreator' || userRole === 'qreviewer')
                          ? 'none'
                          : 'block',
                    }}
                    title={item?.menuName}
                    icon={<FilterOutlined />}
                  >
                    {/* --------------Search */}
                    {item.key !== 'grade' && item.key !== 'status' && (
                    <Menu.Item key={`search_${item.key}`} style={{ height: '100%', position: 'sticky', top: 0, zIndex: 1 }}>
                      <div
                        style={{ padding: '2px', width: '90%', height: '100%', display: 'flex', alignItems: 'center' }}
                        onClick={e => e.stopPropagation()}
                      >
                        <Input
                          placeholder={`Search ${item.menuName}`}
                          onChange={e => handleSearchChange(item.key, e.target.value)}
                          allowClear
                          style={{ width: '100%', paddingBottom: '10px' }}
                          prefix={<Icons.SearchOutlined />}
                        />
                      </div>
                    </Menu.Item>
                  )}
                    {/* --------------Search */}

                    {item?.options?.map((options: any, idx: any) => (
                      <Menu.Item
                        key={`${options.name}${idx}`}
                        icon={<AppstoreOutlined />}
                        // onClick={() => changeFilters(item?.filterKey, options?.id, item?.filterOp)}
                        onClick={() => handleChange(item?.filterKey, options?.id, item?.filterOp, item?.key, options?.name)}
                      >
                        {options.name}
                      </Menu.Item>
                    ))}
                  </Menu.SubMenu>
                ) : null
              ) : (
                <Menu.SubMenu
                  key={`${item?.key}${idx}`}
                  className={selectedKeys.includes(item.key) ? 'ams-filter-item--active' : ''}
                  title={item?.menuName}
                  icon={<FilterOutlined />}
                  style={{
                    display:
                      source !== 'Work Requests' && item?.key === 'status' && (userRole === 'qcreator' || userRole === 'qreviewer')
                        ? 'none'
                        : 'block',
                  }}
                >
                  {item.key !== 'grade' && item.key !== 'status' && (
                    <Menu.Item key={`search_${item.key}`} style={{ height: '100%', position: 'sticky', top: 0, zIndex: 1 }}>
                      <div
                        style={{ padding: '2px', width: '90%', height: '100%', display: 'flex', alignItems: 'center' }}
                        onClick={e => e.stopPropagation()}
                      >
                        <Input
                          placeholder={`Search ${item.menuName}`}
                          onChange={e => handleSearchChange(item.key, e.target.value)}
                          allowClear
                          style={{ width: '100%', paddingBottom: '10px' }}
                          prefix={<Icons.SearchOutlined />}
                        />
                      </div>
                    </Menu.Item>
                  )}
                  {item?.options?.map((options: any, idx: any) => {
                    return (
                      <Menu.Item
                        key={`${options.name}${idx}`}
                        icon={<AppstoreOutlined />}
                        // onClick={() => changeFilters(item?.filterKey, options?.id, item?.filterOp)}
                        onClick={() => handleChange(item?.filterKey, options?.id, item?.filterOp, item?.key, options?.name)}
                      >
                        {options.name}
                      </Menu.Item>
                    )
                  })}

                  {selectedKeys.includes(item.key) && (
                    <Menu.Item
                      key={`remove_${item?.key}`}
                      icon={<CloseCircleOutlined />}
                      onClick={() => handleRemoveFilter(item.key, item?.filterKey, item?.filterOp)}
                      style={{ color: 'red' }}
                    >
                      Remove {item.menuName}
                    </Menu.Item>
                  )}
                </Menu.SubMenu>
              )}
            </>
          )
        )}
      </Menu>
    </div>
  )
}
